//@flow
import React, {PureComponent} from 'react';
import KickImage from 'Reuseables/KickImage';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
} from 'reactstrap';
import propTypes from 'prop-types';
import Countdown from 'react-countdown-now';
import { withRouter } from 'react-router-dom';

import { Button } from '../Forms';
import CountUp from './Count-Forward'
import {
  remaining_time,
  getTimeExpired,
  BANK_TRANSFER,
  VIRTUAL_ACC,
  CREDIT_CARD,
  KREDIVO,
  _PENDING_PAYMENT,
  _VERIYING_PAYMENT,
  _COMPLETED,
  _SENT_BUYER,
  _ON_CANCEL,
  _VERIFIED_FAIL,
  _DONE_BY_ADMIN,
  _DONE_BY_BUYER,
  _VERIFYING_BID
} from '../../utils'

const rendered = ({hours, minutes, seconds, completed}) => {
  if (completed) {
    // Render a completed state
    return (<span id="countdown">Pembayaran Kamu Sudah Kadaluarsa</span>);
  } else {
    // Render a countdown
    return (<span id="countdown">{`${hours} Jam ${minutes} Menit ${seconds} Detik`}</span>);
  }
}

/*
type voidF = (any: any) => void
type Props = {
  history: Object,
  isOpen: boolean,
  payment: {
    invoice_number: string,
    price: string,
    created_at: string,
    expired: string,
    user_sell: Object
  },
  completed: voidF,
  onToggle: voidF
}
type state = {
  disabled: boolean
}
*/

class PaymentPending extends PureComponent {
  static defaultProps;

  state = {
    disabled: false
  }

  _confirmPayment = (invoice_number, expired, payment_method, invoice_url) => {
    let pathname = `/payment_confirmation/${invoice_number}`;
    let {hours, minutes, seconds} = remaining_time(expired);
    if(hours >= 0 && minutes >= 0 && seconds >= 0){
      switch (payment_method) {
        case BANK_TRANSFER[0]: return this.props.history.push({pathname});
        case VIRTUAL_ACC[0]: return window.open(invoice_url, '_blank')
        case CREDIT_CARD[0]: return window.open(invoice_url, '_blank')
        case KREDIVO[0]: return window.open(invoice_url, '_blank')
        default: return null
      }
    }
  }

  _disabled = (expired, statusOffer) => {
    let {hours, minutes, seconds} = remaining_time(expired);

    if(hours >= 0 && minutes >= 0 && seconds >= 0 && (statusOffer === _PENDING_PAYMENT[0] || statusOffer === _VERIFYING_BID[0]))
      return false

    return true
  }

  _paymentMethod = (method, bool) => {
    if(bool){
      switch (method) {
        case BANK_TRANSFER[0]: return BANK_TRANSFER[1]
        case VIRTUAL_ACC[0]: return VIRTUAL_ACC[1]
        case CREDIT_CARD[0]: return CREDIT_CARD[1]
        default: return 'NONE'
      }
    } else {
      switch (method) {
        case BANK_TRANSFER[0]: return "Konfirmasi Pembayaran"
        default: return "SELESAIKAN PEMBAYARAN"
      }
    }
  }

  _sentAddres = (sent) => {
    if(sent)
      return (<span id="detail-sent">{`${sent.street_address}, ${sent.city}, ${sent.province}, ${sent.postal_code}`}</span>)

    return null
  }

  _timeProses = ({invoice_number, price, expired, payment_method, invoice_url, user_sell, statusOffer, sale }) => {
    if(statusOffer === _PENDING_PAYMENT[0] || statusOffer === _VERIFYING_BID[0])
      return (
        <span>
          <span>Batas Waktu: </span><Countdown date={getTimeExpired(expired)} renderer={rendered} />
        </span>
      )
    if(statusOffer === _VERIYING_PAYMENT[0])
      return (`Pembayaran Kamu sedang di Verifikasi Kick Avenue`)
    if(statusOffer === _COMPLETED){
      if(sale && (sale[0].status === _SENT_BUYER[0] || sale[0].status === _DONE_BY_BUYER || sale[0].status === _DONE_BY_ADMIN))
        return (
          <span>
            <span className="display_bold sent-to">ON Courier: <span id="count-up">{`${sale[0].sale_shipping.ka_courier.toUpperCase()}-`}<span id="awb">{`${sale[0].sale_shipping.awb_number}`}</span></span></span>
          </span>
        )
      return (
        <span>
          <span>
            {sale[0].status === _ON_CANCEL[0]||sale[0].status === _VERIFIED_FAIL[0]?`Proses refund harap hubungi Whatsapp: +6281210005425`:`Waktu Proses: `}
          </span>{sale[0].status === _ON_CANCEL[0]||sale[0].status === _VERIFIED_FAIL[0]?null:<CountUp updated_date={sale ? sale[0].updated_at:null}/>}
        </span>
      )
    }

  }

  _completed = (id) => {
    this.setState({disabled: true}, () => {
      this.props.completed(id)
    })
  }

  _renderButton = ({invoice_number, price, expired, payment_method, invoice_url, user_sell, statusOffer, sale }) => {
    if(statusOffer === _PENDING_PAYMENT[0] || statusOffer === _VERIYING_PAYMENT[0] || statusOffer === _VERIFYING_BID[0])
      return (
        <Button
          disabled={this._disabled(expired, statusOffer)}
          className="btn-green bold btn-confirm-payment"
          loadingText="Konfirmasi Pembayaran"
          buttonText={this._paymentMethod(payment_method)}
          block
          size="sm"
          onClick={()=>{this._confirmPayment(invoice_number, expired, payment_method, invoice_url)}}
        />
      )

    if(statusOffer === _COMPLETED && sale[0].status === _SENT_BUYER[0] && !sale[0].completed)
      return(
        <Button
          disabled={this.state.disabled}
          className="btn-green bold btn-confirm-payment"
          loadingText="Mohon Tunggu"
          buttonText={"Package Diterima"}
          block
          size="sm"
          onClick={()=>{this._completed(sale[0].id)}}
        />
      )

    return null
  }

  render(){
    let {invoice_number, price, expired, payment_method, invoice_url, user_sell, statusOffer, shipping } = this.props.payment
      return(
          <Modal isOpen={this.props.isOpen} toggle={this.props.onToggle} className="kick-modal payment-pending">
            <Container id="payment">
              <ModalHeader id="header-payment-pending">
                  ORD ID : <span id="invoice-number">{invoice_number}</span>
              </ModalHeader>
              <ModalBody>
                      <p>
                          <span className="display_bold display_name">{user_sell.product_variant.display_name}</span><br/><br/><br/>
                          Jumlah Total Invoice:<br/><br/>
                          <span className="display_bold price">{`IDR. ${price},-`}</span><br/><br/>
                          {this._paymentMethod(payment_method, true)}<br/><br/>
                          <span className="display_bold kondisi">Kondisi Sneaker</span><br/>
                          {user_sell.sneakers_condition}<br/><br/>
                          <span className="display_bold kondisi">Kondisi Box</span><br/>
                          {user_sell.box_condition}<br/><br/>
                          <span className="display_bold sent-to">Tujuan Pengiriman</span><br/>
                          {/* sent-to stylesnya line-height 1.5rem */}
                          {this._sentAddres(shipping)}<br/><br/><br/>
                          {this._timeProses(this.props.payment)}
                      </p>
              </ModalBody>
              <ModalFooter>
                {this._renderButton(this.props.payment)}
              </ModalFooter>
            </Container>
          </Modal>
      )
  }

  componentDidUpdate(prevProps, prevState){
    if(this.state.disabled && this.props.status_code !== 200 && this.props.status_code !== null)
      this.setState({disabled: false})

  }
}

PaymentPending.propTypes={
    history: propTypes.object,
    payment: propTypes.shape({
      invoice_number: propTypes.string,
      price: propTypes.string,
      created_at: propTypes.string,
      expired: propTypes.string,
      user_sell: propTypes.object
    })
}

PaymentPending.defaultProps={
  payment: {
    invoice_number: "KA-190",
    price: "4.540.000",
    created_at: "22:00:00",
    expired: "2018-01-29 18:07:33",
    user_sell: {product_variant: {}}
  }
}


export default withRouter(PaymentPending)